'use client';
import React, { useState } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from './components/HeroSection';
import ArticleExplorer from './components/ArticleExplorer';
import CuratedCollections from './components/CuratedCollections';
import FeaturedArticle from './components/FeaturedArticle';
import DownloadCTA from './components/DownloadCTA';
import FloatingPill from './components/FloatingPill';

export default function HomePage() {
  const [pillVisible, setPillVisible] = useState(false);

  return (
    <div className="min-h-screen" style={{ background: '#09090B' }}>
      <Header />
      <HeroSection />

      {/* Divider */}
      <div className="max-w-7xl mx-auto px-6">
        <div className="h-px" style={{ background: 'linear-gradient(to right, transparent, rgba(124,58,237,0.2), transparent)' }} />
      </div>

      <ArticleExplorer onFilterInteraction={() => setPillVisible(true)} />

      <div className="max-w-7xl mx-auto px-6">
        <div className="h-px" style={{ background: 'linear-gradient(to right, transparent, rgba(124,58,237,0.15), transparent)' }} />
      </div>

      <CuratedCollections />

      <div className="max-w-7xl mx-auto px-6">
        <div className="h-px" style={{ background: 'linear-gradient(to right, transparent, rgba(124,58,237,0.15), transparent)' }} />
      </div>

      <FeaturedArticle />

      <div className="max-w-7xl mx-auto px-6">
        <div className="h-px" style={{ background: 'linear-gradient(to right, transparent, rgba(124,58,237,0.2), transparent)' }} />
      </div>

      <DownloadCTA />

      <Footer />
      <FloatingPill visible={pillVisible} />
    </div>
  );
}